import React, { useState } from 'react';
import '../BuisnessDashboard/Dashboard.scss';
import Sidebar from './Sidebar';
import MainContent from './MainContent';

export default function Main({pageViewHandler}) {
    const [isSidebarOpen, setIsSidebarOpen] = useState( true );
    const [activeTab, setActiveTab] = useState("dashboard")
    const [activeSubTab, setActiveSubTab] = useState("")

    const handleTabType = (value, type) => {
        if (type == "activeTab") {
            setActiveTab(value?.ShowType)
            setActiveSubTab(value?.subType?.[0]?.ShowType)
        } else if (type == "activeSubTab") {
            setActiveSubTab(value)
        }
    }

     const handleBack=(e)=>{
        pageViewHandler(e,"landingPage")
    }

    return (
        // <div className="Main-dashboard" style={{marginTop:'-10px'}}>
        <div className="Main-dashboard" >
            <div className={`dashboard-sidebar ${isSidebarOpen ? "open" : ""}`}
                // onMouseEnter={() => setIsSidebarOpen(true)}
                // onMouseLeave={() => setIsSidebarOpen(false)}
            >
                <Sidebar
                    handleTabType={handleTabType}
                    isSidebarOpen={isSidebarOpen}
                    activeSubTab={activeSubTab}
                    activeTab={activeTab}
                />
            </div>

            <div className={`dashboard-main-content ${isSidebarOpen ? "open" : ""}`} style={{overflow:'auto' }}>
                <MainContent
                    activeSubTab={activeSubTab}
                    activeTab={activeTab}
                    handleBack={handleBack}
                />
            </div>
        </div>
    );
}
